import { DATA_GEN_AI_DEMO_ISNA_1 } from "./GenAiDemo/206GenAiDemoISNA1";
import { DATA_GEN_AI_DEMO_ISNA_2 } from "./GenAiDemo/207GenAiDemoISNA2";
import { DATA_GEN_AI_DEMO_ISNA_3 } from "./GenAiDemo/208GenAiDemoISNA3";
import { DATA_GEN_AI_DEMO_ISNA_4 } from "./GenAiDemo/209GenAiDemoISNA4";
import { DATA_GEN_AI_DEMO_ISNA_END } from "./GenAiDemo/210GenAiDemoISNAEnd";
import { DATA_INTRO_ISNA } from "./Introduction/201DataIntroISNA";
import { DATA_BENEFITS_ISNA_1 } from "./Introduction/202DataBenefitsISNA1";
import { DATA_BENEFITS_ISNA_2 } from "./Introduction/203DataBenefitsISNA2";
import { DATA_BENEFITS_ISNA_3 } from "./Introduction/204DataBenefitsISNA3";
import { DATA_BENEFITS_ISNA_4 } from "./Introduction/205DataBenefitsISNA4";

export const ISNA_WORKFLOW = [
  {
    page: "ENG_201",
    type: "intro-template" as TemplateType,
    data: DATA_INTRO_ISNA,
  },
  {
    page: "ENG_202",
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_ISNA_1,
  },
  {
    page: "ENG_203",
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_ISNA_2,
  },
  {
    page: "ENG_204",
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_ISNA_3,
  },
  {
    page: "ENG_205",
    type: "benefits-template" as TemplateType,
    data: DATA_BENEFITS_ISNA_4,
  },
  {
    page: "ENG_206",
    type: "journey-one-template" as TemplateType,
    data: DATA_GEN_AI_DEMO_ISNA_1,
  },
  {
    page: "ENG_207",
    type: "journey-one-template" as TemplateType,
    data: DATA_GEN_AI_DEMO_ISNA_2,
  },
  {
    page: "ENG_208",
    type: "journey-one-template" as TemplateType,
    data: DATA_GEN_AI_DEMO_ISNA_3,
  },
  {
    page: "ENG_209",
    type: "journey-one-template" as TemplateType,
    data: DATA_GEN_AI_DEMO_ISNA_4,
  },
  {
    page: "ENG_210",
    type: "end-template" as TemplateType,
    data: DATA_GEN_AI_DEMO_ISNA_END,
  },
];
